import gql from 'graphql-tag';
import ORGANIZATION_FRAGMENT from 'graph/fragments/organization';

const GET_ORGANIZATIONS = gql`
  query getOrganizations {
    organizations(where: { type: [SCHOOL, USER_GROUP] }, orderBy: { field: NAME, direction: ASC }) {
      ...BaseOrganization
      users {
        user {
          id
          firstName
          lastName
          username
        }
      }
    }
  }
  ${ORGANIZATION_FRAGMENT}
`;

export default GET_ORGANIZATIONS;
